import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import PubliList from "./puplicationPopper"

export default function PubliReview() {
  const reviews = useStaticQuery(graphql`
query
{
  allStrapiArticles(sort: {fields: Date, order: DESC}, filter: {Type: {eq: "Review"}}) {
  edges {
    node {
      Abstract
      Type
      Authors
      Illustration {
        publicURL
      }
      url
      Title
      uid
      PDF {
        publicURL
      }
      Journal
      Date(formatString: "YYYY/MM/DD")
      Communications1 {
        publicURL
      }
      Communications2 {
        publicURL
      }
    }
  }
}
}
`)


  return (
    <div className="row1">
      {reviews.allStrapiArticles.edges.map((article, index) => {
        return (
          <PubliList article={article} key={`article__${article.node.id}`}/>
        )
      })}
    </div>
  )
}